<template>
  <div>
    <b-row class="m-0">
      <b-col class="p-0">
        <div class="card mb-0">
          <div class="card-header bg-facebook text-white p-2">
            <h6 class="mb-0"><font-awesome-icon icon="edit" /> Employee Details </h6>

          </div>
          <div class="card-body position-relative p-2">
            <form-component :manpower_id="manpower_id" />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import SwalMixin from '@/views/mixins/Swal.js'
  import FormComponent from './manpower_form/Index.vue';
  import Loader from "@/views/helpers/LoaderComponent.vue";
  export default {
    mixins:[SwalMixin],
    components: {
      Loader,
      FormComponent},
    props:{
      manpower_id: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        is_saving:false
      }
    },
    created(){
    },
    methods: {
    }
  }
</script>
